import Vue from 'vue'
import Vuex from 'vuex'
import api from '../services/api.service'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
})

const getDefaultState = () => {
  return {
    timer: undefined,
    pingTimer: undefined,
    proctoringTimer: undefined,
    test: {
      testId: undefined,
      startDateTime: undefined,
      endDateTime: undefined,
      duration: undefined,
      durationLeft: undefined,
      name: undefined,
      companyName: undefined,
      instructions: '',
      description: '',
      companyId: undefined,
    },
    userEmail: undefined,
    userId: undefined,
    showPopup: false,
    proctoringEventCount: undefined,
    maxAllowedEventViolations: undefined,
    allowCopy: false,
    testRestartCount: undefined,
    currentStep: '',
    testeeStatus: '',
    authenticationEnabled: false,
    proctoringEnabled: false,
    proctoringSettings: undefined,
    webcamMandatory: false,
    micMandatory: false,
    isArchived: false,
    cameraEnabled: false,
    micEnabled: false,
    detectTabSwitch: false,
    detectCopyPaste: false,
    testType: undefined,
    loader: true,
  }
}

export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {
    setProctoringEventCount(state, count) {
      state.proctoringEventCount = count
    },
    setMaxAllowedEventViolations(state, count) {
      state.maxAllowedEventViolations = count
    },
    countDecrement(state) {
      state.proctoringEventCount--
    },
    durationLeftDecrement(state) {
      state.test.durationLeft--
    },
    setUserEmail(state, email) {
      state.userEmail = email
    },
    setTestId(state, testId) {
      state.test.testId = testId
    },
    setStartDateTime(state, dateTime) {
      state.test.startDateTime = dateTime
    },
    setEndDateTime(state, dateTime) {
      state.test.endDateTime = dateTime
    },
    setDuration(state, duration) {
      state.test.duration = duration
    },
    setDurationLeft(state, durationLeft) {
      state.test.durationLeft = durationLeft
    },
    setName(state, name) {
      state.test.name = name
    },
    setCompanyName(state, companyName) {
      state.test.companyName = companyName
    },
    setInstructions(state, instructions) {
      state.test.instructions = instructions
    },
    setDescription(state, desc) {
      state.test.description = desc
    },
    setUserId(state, id) {
      state.userId = id
    },
    setTimer(state, timer) {
      state.timer = timer
    },
    setPingTimer(state, timer) {
      state.pingTimer = timer
    },
    setProctoringTimer(state, timer) {
      state.proctoringTimer = timer
    },
    setTestRestartCount(state, count) {
      state.testRestartCount = count
    },
    setCurrentStep(state, currentStep) {
      state.currentStep = currentStep
    },
    setDefaultState(state) {
      Object.assign(state, getDefaultState())
    },
    setTesteeStatus(state, status) {
      state.testeeStatus = status
    },
    setAuthenticationEnabled(state, status) {
      state.authenticationEnabled = status
    },
    setProctoringEnabled(state, status) {
      state.proctoringEnabled = status
    },
    setProctoringSettings(state, settings) {
      state.proctoringSettings = settings
    },
    setWebcamMandatory(state, status) {
      state.webcamMandatory = status
    },
    setMicMandatory(state, status) {
      state.micMandatory = status
    },
    setArchiveStatus(state, archiveStatus) {
      state.isArchived = archiveStatus
    },
    setCameraEnabled(state, status) {
      state.cameraEnabled = status
    },
    setMicEnabled(state, status) {
      state.micEnabled = status
    },
    setCompanyId(state, companyId) {
      state.test.companyId = companyId
    },
    setDetectTabSwitch(state, status) {
      state.detectTabSwitch = status
    },
    setDetectCopyPaste(state, status) {
      state.detectCopyPaste = status
    },
    setTestType(state, type) {
      state.testType = type
    },
    setLoader(state, loader) {
      state.loader = loader
    },
    setIsCookiedAllowed(state, status) {
      state.isCookieAllowed = status
    }
  },
  actions: {
    endTest(context, router) {
      api.postPing(context.state.test.testId, context.state.userId, context.state.testRestartCount).then(() => {
        console.log('ok')
      })
      api
        .postEndTime(context.state.test.testId, context.state.userId)
        .then(() => {
          console.log('Test Ended')
        })
      console.log('Ending Test!')
      clearInterval(context.state.pingTimer)
      clearInterval(context.state.timer)
      context.commit('setTesteeStatus', 'COMPLETED')
      context.commit('setCurrentStep', 'feedback')
      router.replace({ path: '/feedback' })
    },
    async fetchTest(context, args) {
      context.commit('setTestId', args['test_id'])
      context.commit('setUserEmail', args['email_id'])
      context.commit('setTestType', 'normal-test')
      await api.getTest(args['test_id'], args['email_id']).then(function (response) {
        context.commit('setIsCookiedAllowed', true)
        context.commit('setDurationLeft', response.message['duration'])
        context.commit('setDuration', response.message['duration'])
        context.commit(
          'setStartDateTime',
          new Date(response.message['start_date_time'])
        )
        context.commit('setName', response.message['name'])
        context.commit('setCompanyName', response.message['company_name'])
        context.commit('setInstructions', response.message['instructions'])
        context.commit('setDescription', response.message['description'])
        context.commit('setCompanyId', response.message['company_id'])
        context.commit(
          'setEndDateTime',
          new Date(response.message['end_date_time'])
        )
        console.log(response.message)
        context.commit('setArchiveStatus', response.message['is_archived'])
        context.commit('setAuthenticationEnabled', response.message['proctoring_settings']['authentication_enabled'])
        context.commit('setProctoringEnabled', response.message['proctoring_settings']['proctoring_enabled'])
        context.commit('setProctoringSettings', response.message['proctoring_settings'])
        context.commit('setProctoringEventCount', response.message['proctoring_settings']['number_of_events_for_disqualification'])
        context.commit('setMaxAllowedEventViolations', response.message['proctoring_settings']['number_of_events_for_disqualification'])

        if (response.message['proctoring_settings']['proctoring_enabled'] == true) {
          context.commit('setDetectTabSwitch', response.message['proctoring_settings']['event_detections']['tab_switching'])
          context.commit('setDetectCopyPaste', response.message['proctoring_settings']['event_detections']['copy_paste_detection'])
        }
        if (context.state.proctoringSettings['webcam_enabled'] === true) {
          context.commit('setWebcamMandatory', true)
        }
        if (context.state.proctoringSettings['microphone_enabled'] == true) {
          context.commit('setMicMandatory', true)
        }
        if (response['status'] === 'TEST_NOT_STARTED') {
          context.commit('setCurrentStep', 'not-started')
          args['router'].replace({ path: '/test-not-started' })
        } else if (response['status'] === 'TEST_ENDED') {
          context.commit('setCurrentStep', 'ended')
          args['router'].replace({ path: '/test-ended' })
        }
        context.commit('setLoader', false)
      })
        .catch((err) => {
          context.commit('setIsCookiedAllowed', false)
          console.log(err)
        })
    },
  },
  getters: {
    getDuration(state) {
      var seconds = state.test.duration % 60
      var minutes = Math.floor(state.test.duration / 60) % 60
      var hours = Math.floor(state.test.duration / 3600) % 24

      var time = ''

      if (hours < 10) {
        time = time.concat('0' + hours + ':')
      } else {
        time = time.concat(hours + ':')
      }

      if (minutes < 10) {
        time = time.concat('0' + minutes + ':')
      } else {
        time = time.concat(minutes + ':')
      }

      if (seconds < 10) {
        time = time.concat('0' + seconds)
      } else {
        time = time.concat(seconds)
      }

      return time
    },
    getDurationLeft(state) {
      var seconds = Math.floor(state.test.durationLeft) % 60
      var minutes = Math.floor(state.test.durationLeft / 60) % 60
      var hours = Math.floor(state.test.durationLeft / 3600) % 24

      var time = ''

      if (hours < 10) {
        time = time.concat('0' + hours + ':')
      } else {
        time = time.concat(hours + ':')
      }

      if (minutes < 10) {
        time = time.concat('0' + minutes + ':')
      } else {
        time = time.concat(minutes + ':')
      }

      if (seconds < 10) {
        time = time.concat('0' + seconds)
      } else {
        time = time.concat(seconds)
      }

      return time
    },
    getTimeTaken(state) {
      var timeTaken = state.test.duration - state.test.durationLeft
      var seconds = Math.floor(timeTaken) % 60
      var minutes = Math.floor(timeTaken / 60) % 60
      var hours = Math.floor(timeTaken / 3600) % 24

      var time = ''

      if (hours < 10) {
        time = time.concat('0' + hours + ':')
      } else {
        time = time.concat(hours + ':')
      }
      state.test.startDateTime.getDay()

      if (minutes < 10) {
        time = time.concat('0' + minutes + ':')
      } else {
        time = time.concat(minutes + ':')
      }

      if (seconds < 10) {
        time = time.concat('0' + seconds)
      } else {
        time = time.concat(seconds)
      }

      return time
    },
    getFormattedDate(state) {
      if (!state.test.startDateTime) return ''
      var padZero = function (value) {
        return value > 9 ? value : '0' + value
      }

      var months = [
        'Jan',
        'Feb',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'Sept',
        'Oct',
        'Nov',
        'Dec',
      ]
      return (
        padZero(state.test.startDateTime.getDate()) +
        ' ' +
        months[state.test.startDateTime.getMonth()] +
        ', ' +
        state.test.startDateTime.getFullYear() +
        ' ' +
        padZero(
          state.test.startDateTime.getHours() > 12
            ? state.test.startDateTime.getHours() - 12
            : state.test.startDateTime.getHours()
        ) +
        ':' +
        padZero(state.test.startDateTime.getMinutes()) +
        ' ' +
        (state.test.startDateTime.getHours() >= 12 ? 'PM' : 'AM')
      )
    },
    // This has been added to display End date of test in TestEnded page,
    // ideally this function should take date as an input and return the formatted date
    getFormattedEndDate(state) {
      if (!state.test.endDateTime) return ''
      var padZero = function (value) {
        return value > 9 ? value : '0' + value
      }

      var months = [
        'Jan',
        'Feb',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'Sept',
        'Oct',
        'Nov',
        'Dec',
      ]
      return (
        padZero(state.test.endDateTime.getDate()) +
        ' ' +
        months[state.test.endDateTime.getMonth()] +
        ', ' +
        state.test.endDateTime.getFullYear() +
        ' ' +
        padZero(
          state.test.endDateTime.getHours() > 12
            ? state.test.endDateTime.getHours() - 12
            : state.test.endDateTime.getHours()
        ) +
        ':' +
        padZero(state.test.endDateTime.getMinutes()) +
        ' ' +
        (state.test.endDateTime.getHours() >= 12 ? 'PM' : 'AM')
      )
    },
  },
  plugins: [vuexLocal.plugin],
})
